import React, { useEffect, useState } from 'react'
import { Accordion, Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'
import CurrencyInput from 'react-currency-input-field'
import Select from 'react-select'
import { RichText } from 'src/components'   
import { getEndUser, getPlant2, getPlantV2, getProductName, getProvince3, getSloc } from 'src/api/modules/getdatalist'
import swal from 'sweetalert'
import { stat } from 'fs/promises'
import { getListMaterialAll, getMaterialGroup } from 'src/api/modules/master-data/master'
import { ProductType } from '../../si/FormDetailSIP/RowItem'
import { MultiSelect } from 'react-multi-select-component'
import { KTSVG } from 'src/_metronic/helpers'
import { getCusGrup, getFilterCity } from 'src/api/modules/master-data/master_2'
import { SkeletonForm } from 'src/components/Skeletons'

type DataProps = {
    sector: any;
    incoterm1_id?: any;
    incoterm1?: any;
    incoterm2?: any;
    sales_org?: any;
    sales_org_desc?: string;
    payment_type1?: string;
    payment_type_desc1?: string;
    payment_type2?: string;
    payment_type_desc2?: string;
    distChanel?: any,
    ppn?: number
}

interface PropsItem {
    data: DataProps,
    onAdd(item: any): void
}

export const ModalAddProduct: React.FC<PropsItem> = (props) => {

    const {t} = useTranslation()
    const [show, setShow] = useState(false)
    const [loadingComp, setLoadingComp] = useState(false)
    const [loadingForm, setLoadingForm] = useState(false)
    const [plants, setPlants] = useState<any[]>([])
    const [slocs, setSlocs] = useState<any[]>([])
    const [product_types, setProductTypes] = useState<any[]>([])
    const [products, setProducts] = useState<any[]>([])
    const [provinces, setProvinces] = useState<any[]>([])
    const [cities, setCities] = useState<any[]>([])
    const [segments, setSegments] = useState<any[]>([])
    const [end_users, setEndUsers] = useState<any[]>([])

    const [plant, setPlant] = useState('')
    const [plant_desc, setPlantDesc] = useState('')
    const [sloc, setSloc] = useState('')
    const [sloc_description, sestSlocDescription] = useState('')
    const [product_type, setProductType] = useState('')
    const [product_type_desc, setProductTypeDesc] = useState('')
    const [product_unit, setProductUnit] = useState('')
    const [material_number, setMaterialNumber] = useState('')
    const [product_name, setProductName] = useState('')
    const [product_spec, setProductSpec] = useState('')
    const [fixed_price, setFixedPrice] = useState(0)
    const [fixed_quantum, setfixedQuantum] = useState(0)
    const [price, setPrice] = useState(0)
    const [quantum, setQuantum] = useState(0)
    const [shipping_tolerance_contract, setShippingToleranceContract] = useState(0)
    const [notes, setNotes] = useState('')
    const [end_user, setEndUser] = useState('')
    const [payment_note, setPaymentNote] = useState('')
    const [segment_code, setSegmentCode] = useState('')
    const [segment_name, setSegmentName] = useState('')
    const [include_ppn, setIncludePPN] = useState(false)

    const [province, setProvince] = useState<any>()
    const [province_desc, setProvinceDesc] = useState<any>()
    const [city, setCity] = useState<any>()
    const [cityDesc, setCityDesc] = useState<any>()
    const [isNoEnduser, setIsNoEnduser] = useState(false)
    const [enduserArray, setEnduserArray] = useState<any>([])

    useEffect(() => {
        if (show) {
            loadResources()
        }
    }, [show])

    const loadResources = async () => {
      setLoadingComp(true)
      await Promise.all([getprov(), getMaterialGroupList(), getSegment(), getEndUserr()])
      setLoadingComp(false)
    }

    const getMaterialGroupList = async () => {
        await getMaterialGroup()
            .then((res) => {
                setProductTypes(res.data.data)
            })
    }

    const getprov = async () => {
        let options: Record<string, any> = {}
        if(props.data?.sector?.id == 2) options.customer_code = localStorage.getItem("cust-code")
        await getProvince3(options).then((res) => {
          setProvinces(
            res.data.data.map((item: any) => {
              return {
                value: parseInt(item.sales_office) + '|||' + item.controlling_area,
                label: item.controlling_area,
              }
            })
          )
        })
      }

    const getCities = async () => {
        setLoadingForm(true)
        await getFilterCity(province)
        .then((res) => {
          setCities(
            res.data.data.map((item: any) => {
              return {
                value: item.id + '|||' + item.value,
                label: item.value,
              }
            })
          )
        })
        .finally(() => setLoadingForm(false))
    }
   
      const getSegment = async () => {
        await getCusGrup().then((res) => {
          setSegments(res.data.data)
        })
      }
  
      const getEndUserr = async () => {
        await getEndUser('').then((res) => {
          setEndUsers(res.data.data)
        })
      }
    
    const getProductList = async () => {
      setLoadingForm(true)
      await getProductName('', '', product_type, (props.data?.sales_org?.code || ''), '').then((res) => {
          let tempArray: any[] = [{value: 0 + '|||', label: t('Pilih-productName')}]
          res.data.data.forEach((item: any) => {
              if (item.material_number != 0) {
                  tempArray.push({
                      value: item.material_number + '|||' + item.material_description,
                      label: parseInt(item.material_number) + ' - ' + item.material_description,
                      truevalue: parseInt(item.material_number),
                  })
              }
          })
          setProducts(tempArray)
      })
      setLoadingForm(false)
    }

    const setMultipleState = (value: any, state1: any, state2: any) => {
        const temp = value.split('|||')
        state1(temp[0])
        state2(temp[1])
    }
    
    useEffect(() => {
        if (province) {
            setCity('')
            setCityDesc('')
            getCities()
        }
    }, [province])

    useEffect(() => {
        if (product_type) {
            setProductName('')
            setMaterialNumber('')
            getProductList()
        }
    }, [product_type])

    const validate = (): string => {
        if (
            (props.data?.sector?.id == 1 && enduserArray.length < 1 && isNoEnduser == false) ||
            (isNoEnduser == true && end_user == '') ||
            (props.data?.sector?.id != 1 && end_user == '')
        )
            return t('isi') + t('End Customer')
        else if (!province || province == '0') return t('isi') + t('Province')
        else if (props.data?.sector?.id != 3 && (!city)) return t('isi') + t('City')
        else if (product_type == '') return t('isi') + t('Product Type')
        else if (material_number == '') return t('isi') + t('Product Name')
        else if (price == 0 && (product_type_desc != 'KANTONG/SACK' || product_type != "8105")) {
            return t('isi') + t('Submission Price')
        }
        else if (quantum == 0) return t('isi') + t('Quantum')
        else if (shipping_tolerance_contract < 0) return t('shipping tolerance tidak boleh minus')
        else if (props.data?.sector?.id == 1 && segment_code == '') return t('isi') + 'segment'
        else if (shipping_tolerance_contract >= 100) return t('Shipping tolerance melebihi 100%')
        else return ''
    }

    const clearForm = () => {
      setProvince('')
      setProvinceDesc('')
      setCity('')
      setCityDesc('')
      setProductType('')
      setProductTypeDesc('')
      setProductName('')
      setMaterialNumber('')
      setQuantum(0)
      setPrice(0)
      setShippingToleranceContract(0)
      setIncludePPN(false)
      setPaymentNote('')
      setProductSpec('')
      setSegmentCode('')
      setSegmentName('')
      setNotes('')
      setEndUser('')
      setIsNoEnduser(false)
      setEnduserArray([])
    }
 
    const addProduct = () => {
        const checkValidate = validate()
        if (!checkValidate) {
            props.onAdd({
                incoterm1: {
                    id: props.data?.incoterm1_id,
                    code: props.data?.incoterm1,
                },
                incoterm1_id: props.data?.incoterm1_id,
                incoterm2_id: props.data?.incoterm2,
                sales_org_code: props.data?.sales_org?.code,
                ppn: props.data?.ppn,
                produsen: {
                    code: props.data?.sales_org?.code,
                    name: props.data?.sales_org?.name
                },
                sector_id: props.data?.sector?.id,
                sector: props.data?.sector,
                id: null,
                product_type,
                product_type_desc,
                product_name,
                material_number,
                product_spec,
                quantum,
                price,
                fixed_quantum: quantum,
                fixed_price: price,
                city_id: city,
                city: {
                    id: city,
                    city_name: cityDesc
                },
                province_id: province,
                province: {
                  id: province,
                  region_name: province_desc
                },
                end_user,
                end_user_multiple: !isNoEnduser,
                notes,
                payment_type_1: props.data?.payment_type1,
                payment_type_1_desc: props.data?.payment_type_desc1,
                payment_type_2: props.data?.payment_type2,
                payment_type_2_desc: props.data?.payment_type_desc2,
                payment_note,
                segment_code,
                segment_name,
                shipping_tolerance: 0,
                include_ppn,
                shipping_tolerance_contract,
                attachments: [],
                schedules: [],
                is_new_item: true
            })
            clearForm();
            setShow(false)
        } else {
            swal({
              title: checkValidate,
              icon: 'error',
            })
        }
    }

    const handleUser = (data: any) => {
        let result: any[] = []
        data.forEach((data: any) => {
          result.push(data.value)
        })
        return result
    }

    return (
        <div>
            <button className='btn btn-primary me-2' onClick={() => {
                setShow(true)
            }}>
                + {t('Add New Product')}
            </button>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                backdrop='static'
                keyboard={false}
                scrollable
                size='xl'
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {t('kontrak-tambah')} {t('kontrak-produk')}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {loadingComp ? (
                    <SkeletonForm />
                  ) : (
                    <div>
                      {props.data.sector.id == 3 && (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={props.data?.sales_org?.name}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-incoterm1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={props.data.incoterm1}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-provinsi')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Select
                                    id='provinsi'
                                    placeholder={t('pilih')}
                                    onChange={(e: any) => {
                                      setMultipleState(e?.value, setProvince, setProvinceDesc)
                                    }}
                                    options={provinces}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Select
                                    size='sm'
                                    aria-label='Default select example'
                                    onChange={(e: any) => {
                                      const temp = e.target.value.split('|||')
                                      setMultipleState(e.target.value, setProductType, setProductTypeDesc)
                                      setProductUnit(temp[2])
                                    }}
                                  >
                                    <option hidden value=','>
                                      {t('Pilih-productType')}
                                    </option>
                                    {product_types.map((item: any) => {
                                      return (
                                        <>
                                          <option
                                            value={
                                              [
                                                item.material_group,
                                                item.material_group_desc,
                                                item.unit
                                              ].join("|||")
                                            }
                                          >
                                            {item.material_group_desc}
                                          </option>
                                        </>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {product_type_desc != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      key={product_name}
                                      placeholder={
                                        product_type_desc != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')
                                      }
                                      decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                      groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                      decimalsLimit={3}
                                      onValueChange={(value: any) => {
                                        setQuantum(parseFloat(value?.replace(/,/g, '.')))
                                      }}
                                    />
                                    <InputGroup.Text id='basic-addon2'>
                                      {product_type_desc == 'KANTONG/SACK' ? product_unit : 'MT'}
                                    </InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                </Col>
                                <Col sm={7}>
                                  {product_type_desc != 'KANTONG/SACK' ? (
                                    <InputGroup>
                                      <Form.Control
                                        key={product_name + product_type}
                                        placeholder={t('Shipping Tolerance')}
                                        size='sm'
                                        type='text'
                                        onChange={(e: any) => setShippingToleranceContract(parseInt(e.target.value))}
                                        id='shipping'
                                      />
                                      <InputGroup.Text
                                        id='basic-addon2'
                                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                                      >
                                        <span className='px-1'>%</span>
                                      </InputGroup.Text>
                                    </InputGroup>
                                  ) : (
                                    <InputGroup>
                                      <Form.Control
                                        key={product_name + product_type}
                                        size='sm'
                                        type='number'
                                        onChange={(e: any) => setShippingToleranceContract(parseInt(e.target.value))}
                                        id='shipping'
                                        disabled
                                      />
                                      <InputGroup.Text
                                        id='basic-addon2'
                                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                                      >
                                        <span className='px-1'>%</span>
                                      </InputGroup.Text>
                                    </InputGroup>
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-3'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control size='sm' value={t(props.data?.payment_type_desc1 || '')} disabled />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setNotes(e.target.value)}
                                  />
                                </Col>
                              </Row>

                              <Row className=''>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-endUser')}
                                    {product_type_desc != 'KANTONG/SACK' ? (
                                      <span className='text-danger'>*</span>
                                    ) : (
                                      ''
                                    )}
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    as='textarea'
                                    id='enduser'
                                    placeholder={t('sub-order-endUser')}
                                    onChange={(e: any) => {
                                      setEndUser(e?.target?.value)
                                    }}
                                  />
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={t('Export')}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={props.data?.incoterm2}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>{t('sub-order-kota')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='mt-3'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Select
                                    id='produk'
                                    key={products + product_type_desc}
                                    placeholder={t('pilih') + ' ' + t('sub-order-produk')}
                                    onChange={(e: any) => setMultipleState(e.value, setMaterialNumber, setProductName)}
                                    options={products}
                                    isDisabled={loadingForm}
                                    value={products[products.findIndex((x: any) => x.value == material_number+"|||"+product_name)]}
                                  />
                                </Col>
                              </Row>
                              {parseInt(material_number) == 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => {
                                        setNotes(e.target.value)
                                      }}
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-4'>
                                <Col md={5} className='d-flex align-items-center'>
                                  <p className='fs-6'>
                                    {t('sub-order-hargaP')}/{product_type_desc != 'KANTONG/SACK' ? 'MT' : product_unit}
                                    {product_type_desc != 'KANTONG/SACK' ? (
                                      <span className='text-danger'>*</span>
                                    ) : (
                                      <span className='text-danger'></span>
                                    )}
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <InputGroup size='sm'>
                                    <InputGroup.Text id='basic-addon2'>
                                      <span className='px-2'>USD</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={product_name}
                                      decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                      groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                      decimalsLimit={2}
                                      placeholder={t('sub-order-hargaP')}
                                      onValueChange={(value: any) => {
                                        setPrice(value?.replace(/,/g, '.'))
                                      }}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    placeholder={t('sub-order-spek')}
                                    as='textarea'
                                    id='spek'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setProductSpec(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control size='sm' value={t(props.data?.payment_type_desc2 || '')} disabled />
                                </Col>
                              </Row>
                              {parseInt(material_number) != 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNotes(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      {props.data.sector.id == 1 && (
                        <>
                          <Row>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('kontrak-produsen')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={props.data?.sales_org?.name}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-incoterm1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={props.data?.incoterm1}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-provinsi')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Select
                                    id='provinsi'
                                    placeholder={t('pilih')}
                                    onChange={(e: any) => {
                                      setMultipleState(e?.value, setProvince, setProvinceDesc)
                                    }}
                                    options={provinces}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-jenis')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Select
                                    size='sm'
                                    key={province + city}
                                    aria-label='Default select example'
                                    onChange={(e: any) => {
                                      const temp = e.target.value.split('|||')
                                      setMultipleState(e.target.value, setProductType, setProductTypeDesc)
                                      setProductUnit(temp[2])
                                    }}
                                  >
                                    <option hidden value=','>
                                      {t('Pilih-productType')}
                                    </option>
                                    {product_types.map((item: any, index: number) => {
                                      return (
                                        <option
                                          key={item?.material_group ?? index}
                                          value={
                                            [
                                              item.material_group,
                                              item.material_group_desc,
                                              item.unit
                                            ].join("|||")
                                          }
                                        >
                                          {t(item.material_group_desc)}
                                        </option>
                                      )
                                    })}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {product_type_desc != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <InputGroup size='sm'>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='kuantum'
                                      key={product_name}
                                      placeholder={
                                        product_type_desc != 'KANTONG/SACK' ? t('sub-order-kuantum') : t('sack')
                                      }
                                      decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                      groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                      decimalsLimit={3}
                                      onValueChange={(value: any) => {
                                        setQuantum(parseFloat(value?.replace(/,/g, '.')))
                                      }}
                                    />
                                    <InputGroup.Text id='basic-addon2'>
                                      {product_type_desc != 'KANTONG/SACK' ? (
                                        <span>Ton</span>
                                      ) : (
                                        <span className='pe-1'>{ product_unit }</span>
                                      )}
                                    </InputGroup.Text>
                                  </InputGroup>
                                </Col>
                              </Row>
                              {product_type_desc != 'KANTONG/SACK' ? (
                                <Row className='mb-3'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <InputGroup>
                                      <Form.Control
                                        key={product_name + product_type}
                                        placeholder={t('Shipping Tolerance')}
                                        size='sm'
                                        type='number'
                                        onChange={(e: any) => setShippingToleranceContract(parseInt(e.target.value))}
                                        id='shipping'
                                      />
                                      <InputGroup.Text
                                        id='basic-addon2'
                                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                                      >
                                        <span className='px-1'>%</span>
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                              ) : (
                                <Row className='mb-3'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <InputGroup>
                                      <Form.Control size='sm' type='text' id='shipping' disabled />
                                      <InputGroup.Text
                                        id='basic-addon2'
                                        style={{paddingTop: '1px', paddingBottom: '1px'}}
                                      >
                                        <span className='px-1'>%</span>
                                      </InputGroup.Text>
                                    </InputGroup>
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-payment1')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control size='sm' value={t(props.data?.payment_type_desc1 || '')} disabled />
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    as='textarea'
                                    placeholder={t('keterangan')}
                                    id='keterangan'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => {
                                        setPaymentNote(e.target.value)
                                    }}
                                  />
                                </Col>
                              </Row>

                              {parseInt(material_number) != 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>
                                      {t('segment')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Select
                                      id='segment'
                                      onChange={(e: any) =>
                                        setMultipleState(e.target.value, setSegmentCode, setSegmentName)
                                      }
                                      aria-label='Default select example'
                                      size='sm'
                                    >
                                      <option hidden value=','>
                                        {t('Pilih-segment')}
                                      </option>
                                      {segments.filter((item: any) => (item.code == 'Z2' || item.code == 'Z3')).map((item: any, index) => {
                                        return (
                                            <option key={index} value={item.code + '|||' + item.name}>
                                            {item.name}
                                            </option>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              )}

                              <Row className=''>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-endUser')}
                                    {product_type_desc != 'KANTONG/SACK' ? (
                                      <span className='text-danger'>*</span>
                                    ) : (
                                      ''
                                    )}
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  {isNoEnduser ? (
                                    <>
                                      <Form.Control
                                        size='sm'
                                        as='textarea'
                                        id='enduser'
                                        placeholder={t('sub-order-endUser')}
                                        onChange={(e: any) => {
                                          setEndUser(e.target.value)
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <MultiSelect
                                        options={end_users?.map((item: any) => {
                                          return {label: t(item.name), value: item.name}
                                        })}
                                        value={enduserArray}
                                        onChange={(e: any) => {
                                          let user = handleUser(e)
                                          setEnduserArray(e)
                                          setEndUser(user.toString())
                                        }}
                                        labelledBy='Select'
                                      />
                                    </>
                                  )}
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}></Col>
                                <Col sm={7} className='d-flex align-items-center'>
                                  <Form.Check
                                    onClick={() => {
                                      setIsNoEnduser(!isNoEnduser)
                                    }}
                                    defaultChecked={isNoEnduser}
                                    name='noenduser'
                                    disabled={false}
                                    id='noenduser'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row>
                              {/*

                              <Row className='mb-4'>
                                <Col md={5}></Col>
                                <Col sm={7} className='d-flex align-items-center'>
                                  <Form.Check
                                    onClick={() => {
                                      setIsNoEnduser(!isNoEnduser)
                                    }}
                                    defaultChecked={isNoEnduser}
                                    name='noenduser'
                                    disabled={disableCKBOX}
                                    id='noenduser'
                                    className='mt-5 mb-2'
                                    type='checkbox'
                                  />
                                  {i18next.language == 'en' ? (
                                    <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                  ) : (
                                    <p className='fs-6 mt-2 ms-2'>{t('TidakAdaEndUser')}</p>
                                  )}
                                </Col>
                              </Row> */}
                            </Col>
                            <Col md={6}>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-sektor')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    size='sm'
                                    aria-label='Default select example'
                                    disabled
                                    defaultValue={t('Domestik Korperasi')}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>{t('sub-order-incoterm2')}</p>
                                </Col>
                                {props.data?.incoterm2 != '0' ? (
                                  <Col sm={7}>
                                    <Form.Control
                                      size='sm'
                                      aria-label='Default select example'
                                      disabled
                                      defaultValue={props.data?.incoterm2 ? props.data?.incoterm2 : ''}
                                    />
                                  </Col>
                                ) : (
                                  <Col sm={7}>
                                    <Form.Control
                                      size='sm'
                                      aria-label='Default select example'
                                      disabled
                                      defaultValue={props.data?.incoterm2}
                                    />
                                  </Col>
                                )}
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>
                                    {t('sub-order-kota')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Select
                                    id='kota'
                                    placeholder={t('pilih')}
                                    key={province}
                                    isDisabled={loadingForm}
                                    onChange={(e: any) => {
                                      setMultipleState(e?.value, setCity, setCityDesc)
                                    }}
                                    options={cities}
                                  />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>
                                    {t('sub-order-produk')}
                                    <span className='text-danger'>*</span>
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <Select
                                    id='produk'
                                    key={products + product_type_desc}
                                    placeholder={t('pilih') + ' ' + t('sub-order-produk')}
                                    onChange={(e: any) => setMultipleState(e.value, setMaterialNumber, setProductName)}
                                    options={products}
                                    isDisabled={loadingForm}
                                    value={products[products.findIndex((x: any) => x.value == material_number+"|||"+product_name)]}
                                  />
                                </Col>
                              </Row>
                              {parseInt(material_number) == 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNotes(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              <Row className='mb-2'>
                                <Col md={5} className='d-flex align-items-center'>
                                  <p className='fs-6'>
                                    {t('sub-order-hargaP')}/{product_type_desc != 'KANTONG/SACK' ? 'Ton' : product_unit}
                                    {product_type_desc != 'KANTONG/SACK' ? (
                                      <span className='text-danger'>*</span>
                                    ) : (
                                      ''
                                    )}
                                  </p>
                                </Col>
                                <Col sm={7}>
                                  <InputGroup size='sm'>
                                    <InputGroup.Text id='basic-addon2'>
                                      <span className='px-1'>Rp</span>
                                    </InputGroup.Text>
                                    <CurrencyInput
                                      className='form-control form-control-sm'
                                      id='hargap'
                                      key={product_name}
                                      defaultValue={price}
                                      decimalSeparator={i18next.language === 'en' ? '.' : ','}
                                      groupSeparator={i18next.language === 'en' ? ',' : '.'}
                                      decimalsLimit={(props.data?.sector?.id == 1 ? -1 : 2)}
                                      onValueChange={(value: any) => {
                                            setPrice(parseFloat(value?.replace(/,/g, '.')))
                                      }}
                                      placeholder={t('sub-order-hargaP')}
                                    />
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                </Col>
                                <Col sm={7} className='d-flex justify-content-start'>
                                  {product_type_desc != 'KANTONG/SACK' ? (
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      className='mt-3 mb-2'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      onClick={() => setIncludePPN(!include_ppn)}
                                    />
                                  ) : (
                                    <Form.Check
                                      reverse
                                      name='ppn'
                                      className='mt-3 mb-2'
                                      type='checkbox'
                                      id='ckbox-ppn'
                                      disabled
                                    />
                                  )}
                                </Col>
                              </Row>

                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>{t('sub-order-payment2')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control size='sm' value={t(props.data?.payment_type_desc2 || '')} disabled />
                                </Col>
                              </Row>
                              <Row className='mb-4'>
                                <Col md={5}>
                                  <p className='fs-6 mt-3'>{t('sub-order-spek')}</p>
                                </Col>
                                <Col sm={7}>
                                  <Form.Control
                                    placeholder={t('sub-order-spek')}
                                    as='textarea'
                                    id='spek'
                                    size='sm'
                                    style={{height: '40px'}}
                                    onChange={(e: any) => setProductSpec(e.target.value)}
                                  />
                                </Col>
                              </Row>
                              {parseInt(material_number) != 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='fs-6 mt-3'>{t('sub-order-catatan')}</p>
                                  </Col>
                                  <Col sm={7}>
                                    <Form.Control
                                      as='textarea'
                                      placeholder={t('sub-order-catatan')}
                                      id='note'
                                      size='sm'
                                      style={{height: '40px'}}
                                      onChange={(e: any) => setNotes(e.target.value)}
                                    />
                                  </Col>
                                </Row>
                              )}
                              {parseInt(material_number) == 0 && (
                                <Row className='mb-4'>
                                  <Col md={5}>
                                    <p className='mt-3 fs-6'>
                                      {t('segment')}
                                      <span className='text-danger'>*</span>{' '}
                                    </p>
                                  </Col>
                                  <Col md={7}>
                                    <Form.Select
                                      id='segment'
                                      onChange={(e: any) =>
                                        setMultipleState(e.target.value, setSegmentCode, setSegmentName)
                                      }
                                      aria-label='Default select example'
                                      size='sm'
                                    >
                                      <option hidden value=','>
                                        {t('Pilih-segment')}
                                      </option>
                                      {segments.filter((item: any) => (item.code == 'Z2' || item.code == 'Z3')).map((item: any, index) => {
                                        return (
                                            <option key={index} value={item.code + '|||' + item.name}>
                                            {item.name}
                                            </option>
                                        )
                                      })}
                                    </Form.Select>
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                        </>
                      )}

                      <div className='d-flex justify-content-end mt-5'>
                        <Button variant='primary' onClick={addProduct}>
                          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                          {t('order-kirim')}
                        </Button>
                      </div>
                    </div>
                  )}
                </Modal.Body>
              </Modal>
        </div>
    )
}